import { ReactElement, useEffect, useState } from 'react';
import './style.css';

type PropsButtonWithLoader = {
  isLoading?: boolean
  disabled?: boolean
  onClick?: (data?) => unknown
  children: ReactElement | string
  type?: "button" | "submit"
  onSave?: () => void;
  onChange?: () => void;
  id?: string;
  notVerifyDoubleClick?: boolean;
  message?: string;
  className?: string;
}

function waitSeconds(second: number): Promise<boolean> {
  return new Promise(resolve => {
    setTimeout(() => resolve(true), second * 1000);
  })
}

function ButtonWithLoader(props: PropsButtonWithLoader) {
  const [isLoading, setIsLoading] = useState(props.isLoading);
  const [recentClick, setRecentClick] = useState(false);

  useEffect(() => {
    setIsLoading(props.isLoading)
  }, [props.isLoading])

  const handleClick = async () => {

    if (recentClick && !props.notVerifyDoubleClick) {
      await waitSeconds(1);
      setRecentClick(false)
      return;
    }

    if (props.onClick && (!recentClick || props.notVerifyDoubleClick)) {
      props.onClick()
    }
    setRecentClick(true);
  };

  return (
    <div className="relative group inline-block">
      <button
        id={props.id}
        type={props.type || "submit"}
        className={props.className ? props.className : "button-with-loader disabled:bg-redPrimary/70 w-full mt-2"}
        onClick={handleClick}
        disabled={props.disabled || isLoading}
      >
        <div className="loader flex justify-center items-center absolute top-0 bottom-0 left-0 right-0" style={{ visibility: isLoading ? 'visible' : 'hidden' }}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
        <div style={{ visibility: !isLoading ? 'visible' : 'hidden' }}>
          {props.children}
        </div>
      </button>
      {(props.disabled || isLoading) && props.message && (
        <span className="absolute left-0 bottom-full mb-2 hidden w-40 px-2 py-1 text-xs text-white bg-black rounded group-hover:block z-10">
          {props.message}
        </span>
      )}
    </div>
  );
}

export default ButtonWithLoader;
